import APIService from "./APIService";

export default {
  async getDadosTela1VisaoGeral(competencia, modoPeriodo, ano) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-1-visao-geral",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ano,
        },
      },
    );
    return res.data;
  },

  async getParcelaB() {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-parcela-b",
    );

    return res.data;
  },

  async salvarParcelaB(parcelaB) {
    const res = await APIService.apiCall().post(
      "dashboard-isfp-psfp/salvar-parcela-b",
      {
        parcela_b: parcelaB,
      },
    );
    return res.data;
  },

  async getDadosTela2Tendencia(competencia) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-2-tendencia",
      {
        params: { competencia },
      },
    );
    return res.data;
  },

  // async getDadosTela2SeriePsfp(codigoServico) {
  //   const res = await APIService.apiCall().get(
  //     "dashboard-isfp-psfp/get-dados-tela-2-serie-psfp",
  //     {
  //       params: {
  //         codigos_servico: codigoServico,
  //       },
  //     },
  //   );
  //   return res.data;
  // },

  async getDadosTela2HeatmapTendencia(
    competencia,
    modoPeriodo = "12m",
    ano = null,
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-2-heatmap-tendencia",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ano,
        },
      },
    );
    return res.data;
  },

  async getDadosTela3DetalhamentoResumo(
    competencia,
    modoPeriodo,
    ano,
    servicos,
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-3-resumo",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ano,
          servicos: servicos?.join(",") ?? "",
        },
      },
    );
    return res.data;
  },

  async getDadosTela3DetalhamentoServico(
    competencia,
    modoPeriodo,
    ano,
    servicos,
    codigoServico,
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-3-servico",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ano,
          servicos: servicos?.join(",") ?? "",
          codigos_servico: codigoServico,
        },
      },
    );
    return res.data;
  },

  async getDadosTela3Detalhamento(
    competencia,
    modoPeriodo,
    ano,
    servicos,
    categoriasServicosSelecionadas,
    codigoServico,
  ) {
    const paramsBase = {
      competencia,
      modo_periodo: modoPeriodo,
      ano,
      servicos: servicos?.join(",") ?? "",
    };

    const resumoPromise = APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-3-resumo",
      { params: paramsBase },
    );

    const servicoPromise = codigoServico
      ? APIService.apiCall().get(
          "dashboard-isfp-psfp/get-dados-tela-3-servico",
          { params: { ...paramsBase, codigos_servico: codigoServico } },
        )
      : Promise.resolve({ data: { servico_selecionado: null } });

    const [resResumo, resServico] = await Promise.all([
      resumoPromise,
      servicoPromise,
    ]);

    return {
      ...resResumo.data,
      servico_selecionado: codigoServico
        ? resServico.data.servico_selecionado
        : null,
    };
  },

  async getFiltrosVisaoBrasil() {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-filtros-visao-brasil",
    );
    return res.data;
  },

  async getDadosVisaoBrasilRanking(
    competencia,
    {
      codigoServico,
      modoPeriodo = "12m",
      ano,
      tipoOutorga,
      grupoEconomico,
      uf,
      regiao,
    } = {},
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-4-ranking-empresas",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ...(ano && { ano }),
          ...(codigoServico && { codigo_servico: codigoServico }),
          ...(tipoOutorga && { tipo_outorga: tipoOutorga }),
          ...(grupoEconomico && { grupo_economico: grupoEconomico }),
          ...(uf && { uf }),
          ...(regiao && { regiao }),
        },
      },
    );
    return res.data;
  },

  async getDadosVisaoBrasilDrillEmpresa(
    competencia,
    cnpj,
    { codigoServico, modoPeriodo = "12m", ano } = {},
  ) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-4-drill-empresa",
      {
        params: {
          competencia,
          cnpj,
          modo_periodo: modoPeriodo,
          ...(ano && { ano }),
          ...(codigoServico && { codigo_servico: codigoServico }),
        },
      },
    );
    return res.data;
  },

  async getDadosTela4Simulador(competencia, modoPeriodo, ano, indices) {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-dados-tela-4-simulador",
      {
        params: {
          competencia,
          modo_periodo: modoPeriodo,
          ano,
          indices: indices?.join(",") ?? "",
        },
      },
    );
    return res.data;
  },

  async getListaServicos() {
    const res = await APIService.apiCall().get(
      "dashboard-isfp-psfp/get-lista-servicos",
    );
    return res.data.servicos;
  },
};
